import {CardInfoContent} from '../../../../components/CardInfoGuide/CardInfoGuide'

const accumulationRateInfo: CardInfoContent = {
  title: 'Taxa Base',
  subtitle: 'Regras de Acúmulo',
  items: [
    {
      label: 'Ativar taxa base',
      description:
        'Liga ou desliga o cashback padrão da loja. Se desativado, o cliente só ganha cashback via campanhas específicas de produto, categoria, catálogo ou variação.',
    },
    {
      label: 'Percentual da taxa base',
      description:
        'Percentual padrão de cashback aplicado a qualquer produto que não tenha uma regra própria (Variação, produto, catálogo ou categoria). Ex: 2%.',
    },
  ],
}

const accumulationGroupInfo: CardInfoContent = {
  title: 'Grupo de Cliente',
  subtitle: 'Regras de Acúmulo',
  items: [
    {
      label: 'Taxa Varejo (CPF)',
      description:
        'Percentual de cashback aplicado às compras de clientes Pessoa Física (Taxa base deve estar ativada).',
    },
    {
      label: 'Taxa Atacado (CNPJ)',
      description:
        'Percentual de cashback aplicado às compras de clientes Pessoa Jurídica, geralmente menor devido à margem reduzida do atacado (Taxa base deve estar ativada).',
    },
  ],
}

const accumulationExpirationInfo: CardInfoContent = {
  title: 'Validade do Crédito',
  subtitle: 'Regras de Acúmulo',
  items: [
    {
      label: 'Dias para expiração',
      description:
        'Quantidade de dias até o saldo de cashback expirar após ser ativado. Ex: 30, 60 ou 90 dias. Ajuda a estimular a recompra e evita acúmulo indefinido de passivo.',
    },
  ],
}

const earningLimitsInfo: CardInfoContent = {
  title: 'Limites de Acúmulo',
  subtitle: 'Regras de Acúmulo',
  items: [
    {
      label: 'Teto de ganho por pedido',
      description:
        'Limita o valor máximo financeiro que um cliente pode ganhar de cashback em uma única compra. Útil para proteger o caixa contra compras atípicas muito altas de atacadistas.',
    },
    {
      label: 'Valor mínimo do pedido',
      description:
        'Valor mínimo que a compra precisa ter para que o cliente comece a gerar cashback. Funciona como um gatilho de aumento de ticket médio.',
    },
    // {
    //   label: 'Gerar sobre o frete',
    //   description:
    //     'Define se o valor pago no frete pelo cliente também gera cashback. O padrão de mercado é "Não".',
    // },
  ],
}

const marginProtectionInfo: CardInfoContent = {
  title: 'Proteção',
  subtitle: 'Regras de Acúmulo',
  items: [
    {
      label: 'Apenas produtos com regras cadastradas',
      description:
        'Se ativado como "Sim", o cashback só será gerado para itens que possuam regras específicas cadastradas (variação, produto, categoria ou catálogo). Se "Não", qualquer produto da loja poderá acumular cashback usando as taxas base (Se configuradas).',
    },
  ],
}

const redemptionCapInfo: CardInfoContent = {
  title: 'Teto de Abatimento',
  subtitle: 'Regras de Resgate',
  items: [
    {
      label: 'Percentual máximo do pedido',
      description:
        'Limita o quanto do valor total do novo pedido pode ser pago com saldo de cashback, evitando que um pedido saia inteiro de graça.',
    },
  ],
}

const redemptionMinimumsInfo: CardInfoContent = {
  title: 'Valores Mínimos',
  subtitle: 'Regras de Resgate',
  items: [
    {
      label: 'Valor mínimo de saldo',
      description: 'Saldo mínimo que o cliente precisa ter para conseguir usar o cashback.',
    },
    {
      label: 'Valor mínimo do carrinho',
      description: 'Valor mínimo que a nova compra precisa ter para permitir o uso do cashback.',
    },
  ],
}

const redemptionBaseInfo: CardInfoContent = {
  title: 'Base de Cálculo',
  subtitle: 'Regras de Resgate',
  items: [
    {
      label: 'Incidir sobre o frete',
      description:
        'Define se o desconto de cashback também é aplicado para pagar o valor do frete. Recomendado manter "Não".',
    },
  ],
}

const antifraudCooldownInfo: CardInfoContent = {
  title: 'Carência',
  subtitle: 'Blindagem e Antifraude',
  items: [
    {
      label: 'Dias de carência',
      description:
        'Número de dias em que o saldo fica "Pendente" antes de virar "Disponível". Evita o golpe de gerar, usar e depois estornar o pedido de origem. Recomenda-se um prazo igual ao prazo legal de devolução.',
    },
  ],
}

const antifraudStackingInfo: CardInfoContent = {
  title: 'Acúmulo',
  subtitle: 'Blindagem e Antifraude',
  items: [
    // {
    //   label: 'Permitir uso com cupons',
    //   description:
    //     'Define se o cashback pode ser usado junto com cupons de desconto no mesmo pedido. Se "Não", o cliente escolhe qual benefício usar no checkout.',
    // },
    {
      label: 'Itens promocionais',
      description:
        'Se configurado para proteger margem, produtos que já estão com preço promocional (desconto "De/Por" aplicado) não gerarão cashback.',
    },
  ],
}

const antifraudAutoRefundInfo: CardInfoContent = {
  title: 'Estorno Automático',
  subtitle: 'Blindagem e Antifraude',
  items: [
    {
      label: 'Estorno automático',
      description:
        'Quando o pedido de origem é cancelado, estornado ou recusado pelo gateway, o sistema reverte automaticamente o cashback gerado.',
    },
  ],
}

const walletCapInfo: CardInfoContent = {
  title: 'Limite da Carteira',
  subtitle: 'Blindagem e Antifraude',
  items: [
    {
      label: 'Saldo máximo permitido',
      description:
        'O valor máximo que o cliente pode acumular na carteira. Se atingir esse teto, ele é obrigado a usar o saldo antes de poder acumular mais. 0 = Ilimitado.',
    },
  ],
}

export {
  accumulationRateInfo,
  accumulationGroupInfo,
  accumulationExpirationInfo,
  earningLimitsInfo,
  marginProtectionInfo,
  redemptionCapInfo,
  redemptionMinimumsInfo,
  redemptionBaseInfo,
  antifraudCooldownInfo,
  antifraudStackingInfo,
  antifraudAutoRefundInfo,
  walletCapInfo,
}
